// dw-reviews.js
//
// 2026-08-25, per Cosette — PER-REVIEW DATES NOW WORK. This corrects the
// 2026-07-24 conclusion below, which is left intact underneath because the
// scroll-jack account in it still matters. The claim that needs correcting
// is this one: "Two things confirmed NOT available anywhere (neither the API
// nor the DOM) on this widget version: a review title, and a per-review
// date."
//
// The DOM half is still true. Judge.me's current .jm-review-item markup
// really does not render a date. The API half was wrong, and wrong for a
// specific, findable reason: the endpoint tested was Judge.me's MERCHANT
// API (GET /api/v1/reviews), which does require a shop-level private token
// and correctly rejects the public one. Judge.me's own widget does not use
// that endpoint. It uses this one:
//
//   https://judge.me/reviews/reviews_for_widget
//     ?url=<shop>&shop_domain=<shop>&platform=shopify
//     &page=1&per_page=100&product_id=<id>
//
// which takes NO token of any kind and returns created_at for every review.
// CONFIRMED LIVE 2026-08-25 from deawellness.com's own origin, in a real
// browser: CORS allowed, HTTP 200, all 3 Harmonia reviews returned, 3/3
// matched to their rendered cards. See the PER-REVIEW DATES section further
// down for the implementation and its failure modes.
//
// Two related things also confirmed live, correcting earlier guesses:
//   - The API's `title` is "" for every review — the current Judge.me form
//     doesn't collect one, so there is nothing to wire [data-field="title"]
//     up to. Left blank deliberately, not by oversight.
//   - The Verified Buyer badge ALREADY WORKS. The selector in
//     scrapeReviews() was assumed dead in the note below; it isn't, all
//     three cards render the badge. Nothing to fix there.
// So of the three long-blank fields, only the date was genuinely missing.
//
// Feeding real dates in also fixed a second, quieter bug: the "Most Recent"
// sort had never sorted. applySortAndRender() compared `new Date("")` to
// `new Date("")`, which is NaN, and every comparison involving NaN is
// false — so the comparator was a silent no-op and the list just stayed in
// scrape order no matter what the dropdown said. The comparator now checks
// for unparseable dates explicitly instead of relying on date arithmetic.
//
// -----------------------------------------------------------------------
//
// NOTE: this file is stored in the project under the legacy singular
// filename "dw-review.js" but the actual live asset (referenced by
// sections/dw-reviews-section.liquid via {{ 'dw-reviews.js' | asset_url }})
// is named "dw-reviews.js" (plural).
//
// 2026-07-24 rewrite #2, per Cosette — the 2026-07-24 rewrite #1 (which
// replaced DOM scraping with a direct fetch() to Judge.me's public Reviews
// API) fixed the scroll-jack but broke the review list itself — every
// product now showed the empty "No reviews yet" state instead of its real
// reviews. Confirmed live on this store's actual widget (Harmonia,
// 8 reviews): fetching the exact same public-Reviews-API URL this file
// was calling returns
//   {"error":"You are using a public token which does not have enough
//   permissions. Please try to use a more authoritative token."}
// Judge.me's GET /api/v1/reviews endpoint requires a shop-level PRIVATE
// API token to return review contents — the public token (the same one
// this file already had hardcoded for the old date-backfill call) is not
// enough, and Judge.me correctly rejects it. This means the old
// fetchDates() backfill call was *also* always silently failing this same
// way from day one (its failures were only logged behind DEBUG, and losing
// just the date was never noticed) — this isn't a new regression, it's a
// pre-existing dead code path that rewrite #1 mistakenly treated as a
// proven-working data source. A private token is NOT an option here
// either way: it would have to ship inside this public JS file for the
// browser to use it, and a private Judge.me token can read/export
// customer emails and moderate/delete reviews — that must never be
// client-side-visible.
//
// [2026-08-25: all of the above is still accurate about /api/v1/reviews.
// It just isn't the endpoint the widget uses — see the correction at the
// top of this file.]
//
// So this rewrite reverts to reading reviews out of Judge.me's own
// widget DOM (scrapeReviews()/harvestAllReviews()/mergeReviews(), as
// before rewrite #1) — re-verified live against the real, current widget
// markup on this store (not just assumed from old comments): the
// .jm-review-item / .jm-star-rating / .jm-reviewer-info__name /
// .jdgm-review-content__body-content / .jm-pagination-controls
// selectors below all match the actual rendered DOM.
//
// THE ACTUAL SCROLL-JACK FIX (this is the part that matters, not the
// data source): harvesting still requires programmatically clicking
// Judge.me's own hidden "next page" pagination button, and clicking a
// real focusable element can still make the browser want to scroll it
// into view. The 2026-07-23 fix tried to catch and undo that scroll
// per-click, in a short (500ms) window right around each click
// (clickWithoutScrolling(), kept below) — but harvesting a multi-page
// product fires several of these clicks in sequence with settle delays
// between them, and if Judge.me's own JS does a delayed/animated
// scrollIntoView() after a page change that lands outside that narrow
// per-click window, nothing was left watching to undo it. Rather than
// trying to out-guess that timing, lockPageScroll()/unlockPageScroll()
// below freeze the page's scroll entirely (the same overflow:hidden
// technique this file already uses for the write-review-modal-open state
// and the lightbox — see document.body.style.overflow elsewhere) for the
// ENTIRE harvest walk, not just around each individual click. With
// overflow:hidden on <html> and <body>, there is no scrollable range for
// any scrollIntoView()/scrollTo() call — Judge.me's, the browser's
// native focus handling, or anything else — to move the page to, no
// matter when it fires relative to any single click. The per-click
// clickWithoutScrolling() stays in place too as a second layer, but the
// scroll lock is what actually closes the timing gap.
//
// The "Write a Review" button (openWriteReview()) keeps the fix from
// earlier today: it reveals the real Judge.me widget (normal, unclipped,
// in-flow) for the moment of the click instead of clicking it while
// still visually hidden, then hides it again right after. That path is
// unrelated to today's regression (it only ever fires from the user's
// own click, not automatically on page load) and was not reverted.
//
// 2026-08-05, per Cosette — write-review modal product photo not
// rendering. THIS VERSION IS LIVE-TESTED, not just theorized: rather
// than trust the earlier same-day write-up below (which turned out to
// still not be enough — the code it described was never actually this
// far along), the exact fetch-and-swap logic below was run directly
// against the real, live modal on this exact product page in a real
// Chrome session and CONFIRMED to render the product photo correctly
// before being put in this file. Keeping the investigation notes below
// since they explain the underlying races that make this fragile, but
// don't take "should work" on faith this time — it was actually seen
// working, live, moments before this file was written.
//
// Confirmed live in that same session:
//   - Judge.me does NOT render any <img> for the product photo in this
//     modal on its own, ever, in any state observed. There is no native
//     element to "fix" — this file has to build the image element
//     itself, unconditionally, every time.
//   - Loading the product's image_url as a plain <img src="..."> FAILS
//     (its error handler fires) even though the exact same URL returns
//     200 with real image/jpeg bytes when requested via fetch(). This is
//     a real, reproducible gap between how the browser requests an
//     <img>'s bytes vs. a script-driven fetch() of the same URL (almost
//     certainly an Accept-header content-negotiation difference on
//     Shopify's/Judge.me's image host) — not a one-off fluke from a
//     recently-uploaded file. The fetch()-to-blob-URL approach below
//     sidesteps it entirely by never letting the browser make that
//     native <img> request against the original URL at all.
//   - modal.querySelector(".jdgm-write-review-modal__form") can match
//     MORE THAN ONE element — Judge.me renders a separate
//     ".jdgm-write-review-modal__form" for the rating page, the
//     share-media page, and the thank-you page, all at once in the DOM
//     (only one is ever the visible/current page). querySelector()
//     always returns the FIRST one in document order, which in every
//     observed case was the rating-page's form — the one that actually
//     contains ".jdgm-write-review-modal__product-title" and is visible
//     when the modal first opens. This happens to work for the "add
//     the photo above the title on the rating page" goal, but is worth
//     knowing if a future change wants the photo somewhere else too.
//
// 2026-08-05, per Cosette — separately, "reviews section stuck forever
// on 'Loading reviews...'". Reproduced live TWICE in a row on a
// completely fresh page load of this exact product, using the code
// already live on the site before any change from today's session —
// this is a pre-existing bug, not a regression from the fix above.
// Root cause, confirmed live via the console: Judge.me's own widget
// loader intermittently fails part of its own startup ("Could not load
// manifest or CSS files: TypeError: Failed to fetch") and, when that
// happens, can rebuild its ENTIRE .jdgm-widget element rather than just
// updating its contents in place. waitForJudgeMe() below only ever
// captures that element once; observeWidget()'s MutationObserver is
// attached directly to that one captured node. Once Judge.me swaps in a
// replacement node, the observer is left watching a detached element
// that will never mutate again, so scrapeAndRender() never runs again —
// the loading state has no way to recover, even though the real
// (empty-state) widget is sitting right there in the live DOM.
//
// Fixed two ways below, in observeWidget()/refreshWidgetReference():
//   1. A second MutationObserver, scoped to jdgmHost (the outer
//      shopify-app-block container, which Judge.me does not itself
//      replace — only the .jdgm-widget it contains), re-resolves the
//      live .jdgm-widget on any change under that host and re-points
//      this.jdgmWidget + the primary observer at it whenever Judge.me
//      has swapped it out. This is what actually recovers from the
//      exact failure confirmed live above.
//   2. A 15-second hard timeout as a last-resort safety net: if the
//      loading state still hasn't resolved by then for any reason
//      (including a genuine, sustained Judge.me outage this file can't
//      route around), fall back to the empty state rather than leaving
//      customers looking at a spinner that will never finish.

(function () {
  "use strict";
  var DEBUG = false;
  function log() {
    DEBUG &&
      window.console &&
      console.log.apply(console, ["[dw-reviews]"].concat(Array.prototype.slice.call(arguments)));
  }

  var starIconUidCounter = 0;
  function starSVG(filled) {
    starIconUidCounter++;
    var uid = "rc" + starIconUidCounter;
    return (
      '<svg width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0-' +
      uid +
      ')"><g clip-path="url(#clip1-' +
      uid +
      ')"><path d="M11.7798 4.36341C11.7276 4.21793 11.632 4.09197 11.5059 4.00255C11.3798 3.91313 11.2293 3.86457 11.0748 3.86341H8.02979C7.97841 3.86339 7.92828 3.84754 7.88623 3.81802C7.84419 3.78849 7.81225 3.74673 7.79479 3.69841L6.70479 0.598413C6.64799 0.457999 6.55052 0.33776 6.42491 0.253126C6.29929 0.168491 6.15125 0.123321 5.99979 0.123413C5.84573 0.12415 5.69569 0.172629 5.57033 0.262173C5.44497 0.351718 5.35045 0.477924 5.29979 0.623413L4.20479 3.70841C4.18732 3.75673 4.15539 3.79849 4.11334 3.82802C4.07129 3.85754 4.02116 3.87339 3.96979 3.87341H0.924785C0.770049 3.87385 0.619235 3.92213 0.493019 4.01165C0.366803 4.10116 0.271364 4.22753 0.219785 4.37341C0.170185 4.51763 0.165119 4.67343 0.205246 4.82056C0.245373 4.96769 0.328837 5.09935 0.444785 5.19841L3.03479 7.34841C3.0737 7.38017 3.10215 7.42292 3.11642 7.47108C3.13069 7.51924 3.13012 7.57058 3.11479 7.61841L2.02479 10.8834C1.97345 11.0346 1.9717 11.1982 2.01978 11.3504C2.06786 11.5027 2.16327 11.6356 2.29212 11.7299C2.42097 11.8241 2.57654 11.8748 2.73619 11.8746C2.89584 11.8743 3.05125 11.8231 3.17979 11.7284L5.84979 9.76841C5.89228 9.73637 5.94406 9.71904 5.99729 9.71904C6.05051 9.71904 6.10229 9.73637 6.14479 9.76841L8.81979 11.7284C8.94733 11.8345 9.10648 11.8954 9.27229 11.9014C9.43811 11.9074 9.60124 11.8583 9.73614 11.7617C9.87105 11.665 9.97011 11.5264 10.0178 11.3675C10.0655 11.2086 10.0592 11.0383 9.99979 10.8834L8.90979 7.61841C8.89445 7.57058 8.89388 7.51924 8.90815 7.47108C8.92242 7.42292 8.95087 7.38017 8.98979 7.34841L11.5848 5.19341C11.6971 5.09082 11.7759 4.95668 11.8107 4.80857C11.8455 4.66046 11.8347 4.5053 11.7798 4.36341Z" fill="' +
      (filled ? "#835049" : "#E4E4E4") +
      '"/></g></g><defs><clipPath id="clip0-' +
      uid +
      '"><rect width="12" height="12" fill="white"/></clipPath><clipPath id="clip1-' +
      uid +
      '"><rect width="12" height="12" fill="white" transform="translate(-0.000244141 -0.00158691)"/></clipPath></defs></svg>'
    );
  }

  var ICONS = {
    chevronLeft:
      '<svg width="10" height="10" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.2664 0.333328L3.8831 7.75066C3.84785 7.78194 3.81963 7.82033 3.80031 7.86331C3.78099 7.90629 3.771 7.95287 3.771 7.99999C3.771 8.04712 3.78099 8.0937 3.80031 8.13668C3.81963 8.17966 3.84785 8.21805 3.8831 8.24933L12.2664 15.6667" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    chevronRight:
      '<svg width="10" height="10" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.76709 15.6667L12.1511 8.24933C12.1863 8.21805 12.2146 8.17966 12.2339 8.13668C12.2532 8.0937 12.2632 8.04712 12.2632 7.99999C12.2632 7.95287 12.2532 7.90629 12.2339 7.86331C12.2146 7.82033 12.1863 7.78194 12.1511 7.75066L3.76709 0.333328" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  };

  function starsMarkup(rating) {
    for (var html = "", r = Math.round((rating || 0) * 2) / 2, i = 1; i <= 5; i++) html += starSVG(i <= r);
    return html;
  }

  // 2026-08-25, per Cosette — month changed from "long" to "short" to match
  // the Figma (node 2126-4300), which shows "Aug 25, 2026" in the review
  // card's top-right, not "August 25, 2026". Nothing else about the format
  // changes: same en-US locale, numeric day, numeric year.
  function formatDate(dateStr) {
    if (!dateStr) return "";
    var d = new Date(dateStr);
    return isNaN(d.getTime()) ? dateStr : d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  }

  // ---------------------------------------------------------------------
  // PER-REVIEW DATES (2026-08-25, per Cosette) — see the correction at the
  // top of this file for why this endpoint works when /api/v1/reviews
  // doesn't.
  //
  // Everything in this section fails soft, by design. No product id, no
  // fetch support, a CORS refusal, a Judge.me outage, a reviewer whose
  // name doesn't match anything — any of those leaves dateRaw as "" and
  // the section behaves exactly as it did before dates existed. There is
  // no path here that can break the review list.
  //
  // Note: per_page is capped at 30 server-side no matter what you ask for
  // (confirmed live — requesting 100 comes back with pagination.per_page
  // of 30), hence the pagination walk rather than one big request.
  // ---------------------------------------------------------------------
  var reviewDates = null;
  var reviewDatesState = "idle";
  var reviewDatesWaiting = [];

  function normText(str) {
    return (str || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  // body_html is remote HTML. DOMParser builds an inert document that is
  // never attached to this page, so nothing inside it can execute or load
  // — we only ever read textContent back out of it.
  function stripHtml(html) {
    if (!html) return "";
    try {
      var doc = new DOMParser().parseFromString(html, "text/html");
      return (doc.body && doc.body.textContent) || "";
    } catch (e) {
      return String(html).replace(/<[^>]*>/g, " ");
    }
  }

  // This is an asset file and can't read Liquid, so every source below is
  // something already present in the rendered page at runtime. All five
  // were checked live on the Harmonia page and every one returned
  // 9165445497059 — this chain is over-provisioned on purpose.
  function getProductId() {
    var widget = document.querySelector(".jdgm-widget");
    if (widget) {
      var attr = widget.getAttribute("data-product-id") || widget.getAttribute("data-id");
      if (attr && /^\d+$/.test(attr)) return attr;
    }
    // Judge.me's own inline data blob — the same script tag
    // fixProductImageLoad() below already reads image_url out of, so it's
    // a known-present element on this store.
    var dataScript = document.querySelector("script.jdgm-review-widget-data");
    if (dataScript) {
      var m = dataScript.textContent.match(/"product_external_id"\s*:\s*"?(\d+)"?/);
      if (m) return m[1];
    }
    try {
      if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
        return String(ShopifyAnalytics.meta.product.id);
      }
    } catch (e) {}
    try {
      if (window.meta && window.meta.product) return String(window.meta.product.id);
    } catch (e) {}
    return null;
  }

  // Confirmed live: window.Shopify.shop is "sid151-3h.myshopify.com" and
  // the endpoint accepts it; the custom domain works too. Either is fine.
  function getShopDomain() {
    try {
      if (window.Shopify && window.Shopify.shop) return window.Shopify.shop;
    } catch (e) {}
    return window.location.hostname;
  }

  function fetchReviewDates(done) {
    var productId = getProductId();
    var shop = getShopDomain();
    if (!productId || !window.fetch) {
      log("No product id (or no fetch support) — review dates will stay blank.");
      done([]);
      return;
    }

    var collected = [];
    var page = 1;

    function requestPage() {
      var url =
        "https://judge.me/reviews/reviews_for_widget" +
        "?url=" + encodeURIComponent(shop) +
        "&shop_domain=" + encodeURIComponent(shop) +
        "&platform=shopify" +
        "&page=" + page +
        "&per_page=100" +
        "&product_id=" + encodeURIComponent(productId);

      fetch(url, { mode: "cors", credentials: "omit" })
        .then(function (res) {
          if (!res.ok) throw new Error("HTTP " + res.status);
          return res.json();
        })
        .then(function (data) {
          (data.reviews || []).forEach(function (r) {
            if (!r || !r.created_at) return;
            collected.push({
              name: normText(r.reviewer_name),
              body: normText(stripHtml(r.body_html)),
              createdAt: r.created_at,
            });
          });
          var pagination = data.pagination || {};
          if (page < (pagination.total_pages || 1) && page < 10) {
            page++;
            requestPage();
            return;
          }
          log("Loaded " + collected.length + " review date(s).");
          done(collected);
        })
        .catch(function (err) {
          log("Could not load review dates (" + err + ") — leaving them blank.");
          done(collected);
        });
    }

    requestPage();
  }

  // One request per page load, shared by every widget instance, with any
  // caller that asks before it lands queued rather than re-requesting.
  function whenReviewDates(cb) {
    if (reviewDatesState === "done") {
      cb(reviewDates);
      return;
    }
    reviewDatesWaiting.push(cb);
    if (reviewDatesState === "loading") return;
    reviewDatesState = "loading";
    fetchReviewDates(function (rows) {
      reviewDates = rows || [];
      reviewDatesState = "done";
      var queued = reviewDatesWaiting;
      reviewDatesWaiting = [];
      queued.forEach(function (fn) {
        fn(reviewDates);
      });
    });
  }

  function commonPrefixLength(a, b) {
    var max = Math.min(a.length, b.length);
    var i = 0;
    while (i < max && a.charCodeAt(i) === b.charCodeAt(i)) i++;
    return i;
  }

  // Judge.me exposes no stable id on .jm-review-item (see dedupeKey()
  // below, which has the same problem), so scraped reviews have none to
  // match on either. Match on reviewer name; where one name has left
  // several reviews, disambiguate on how far their bodies agree. Compare
  // on a PREFIX, never on equality — the scraped body can be truncated by
  // a "Read more" affordance while the API body is complete. If two
  // same-name reviews don't agree on their opening words, return nothing:
  // a blank date beats a wrong one.
  function matchReviewDate(rows, review) {
    var wantName = normText(review.name);
    if (!wantName) return null;

    var candidates = rows.filter(function (r) {
      return r.name === wantName;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];

    var wantBody = normText(review.body);
    var best = null;
    var bestScore = 0;
    candidates.forEach(function (r) {
      var score = commonPrefixLength(r.body, wantBody);
      if (score > bestScore) {
        bestScore = score;
        best = r;
      }
    });
    return bestScore >= 20 ? best : null;
  }

  // 2026-07-24, per Cosette — removing the wrong early broadcast (see the
  // 2026-07-24 note in waitForJudgeMe() below) traded "shows 8, corrects
  // to 7" for "shows the merchant's placeholder text, corrects to 7" —
  // still a flash of something that isn't the real answer, just fixed
  // to always be the default text instead of a wrong number. The actual
  // fix: cache the last real (count > 0) result in localStorage every
  // time we get one, so any repeat view of this page (refresh, back/
  // forward, a normal return visit) can paint the real, correct numbers
  // immediately, before Judge.me's widget has even loaded, with nothing
  // false shown in between. See the matching read of this same key at
  // the top of the <script> block in dw-product-section.liquid. Only a
  // genuine first-ever visit (nothing cached yet) still briefly shows
  // the merchant's placeholder while the real data loads — there's no
  // way around that one without a server-side data source, which Judge.me
  // doesn't give us here (see the top-of-file note on the blank metafield).
  //
  // 2026-08-01, per Cosette — this used to only ever WRITE the cache (on
  // count > 0), never clear it. After archiving every review on a
  // product, this same function gets called with a genuine (count, 0)
  // from showEmpty() below, but the last real (count > 0) cache entry
  // from before the archive was left sitting in localStorage — so a hard
  // refresh / page-to-page nav kept synchronously painting that stale
  // old count for a moment (the read at the top of dw-product-section.
  // liquid's <script> block) before this same real 0 corrected it back
  // down — the flash Cosette reported. Clearing the cache on a genuine
  // zero here means the very next confirmed-zero scrape wipes the stale
  // entry, so later loads have nothing false left to read before Judge.me
  // answers again.
  function broadcastSummary(count, average) {
    if (count > 0) {
      try {
        window.localStorage.setItem("dw-reviews-summary", JSON.stringify({ count: count, average: average }));
      } catch (e) {}
    } else {
      try {
        window.localStorage.removeItem("dw-reviews-summary");
      } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent("dw:reviews:summary", { detail: { count: count, average: average } }));
  }

  // ---------------------------------------------------------------------
  // Whole-page scroll lock — see the top-of-file note. Module-scoped
  // (not per-widget-instance) with a simple ref count, since only one
  // ReviewsWidget exists per product page but this is harmless if that
  // ever changes.
  //
  // 2026-07-24 hardening, per Cosette — this lock is fine on Chrome but
  // Safari still showed a flash/jump on it. Two Safari-specific gaps,
  // both fixed here:
  //   1. overflow:hidden on <html>/<body> alone is the desktop-safe lock,
  //      but is well known NOT to reliably block scrolling on Safari —
  //      Safari can still move the visual viewport out from under a
  //      overflow:hidden body. The standard cross-engine-safe fix is the
  //      "position:fixed the body" trick: pin body in place at its
  //      current scroll offset so there is no scrollable viewport at all
  //      for anything to move, then undo it and restore the exact
  //      position afterward.
  //   2. clickWithoutScrolling() used to call el.focus({preventScroll:
  //      true}) before every click. Safari has a long-documented bug
  //      where preventScroll is unreliable specifically for elements
  //      that are clipped/positioned like this file's "visually hidden"
  //      Judge.me host (position:absolute + clip-rect + 1px) — Safari
  //      also doesn't focus <button> elements on a real mouse click by
  //      default in the first place (unlike Chrome), so this file was
  //      the one FORCING a focus Safari otherwise wouldn't have
  //      attempted, straight into a case its own preventScroll bug
  //      doesn't handle. That explicit focus() call is removed below —
  //      el.click() alone is enough to drive Judge.me's own click
  //      handler, and the whole-page lock is what actually has to hold.
  var scrollLockDepth = 0;
  var scrollLockState = null;
  function lockPageScroll() {
    scrollLockDepth++;
    if (scrollLockDepth > 1) return;
    var y = window.scrollY;
    scrollLockState = {
      y: y,
      htmlOverflow: document.documentElement.style.overflow,
      bodyOverflow: document.body.style.overflow,
      bodyPosition: document.body.style.position,
      bodyTop: document.body.style.top,
      bodyWidth: document.body.style.width,
    };
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    // The position:fixed pin is what actually holds on Safari — overflow
    // hidden alone is the belt, this is the suspenders.
    document.body.style.position = "fixed";
    document.body.style.top = "-" + y + "px";
    document.body.style.width = "100%";
  }
  function unlockPageScroll() {
    if (scrollLockDepth === 0) return;
    scrollLockDepth--;
    if (scrollLockDepth > 0) return;
    document.documentElement.style.overflow = scrollLockState.htmlOverflow;
    document.body.style.overflow = scrollLockState.bodyOverflow;
    document.body.style.position = scrollLockState.bodyPosition;
    document.body.style.top = scrollLockState.bodyTop;
    document.body.style.width = scrollLockState.bodyWidth;
    // Un-pinning body from position:fixed drops the page back to
    // scrollY 0 until we explicitly restore it — do that instantly
    // (no smooth animation) so it reads as "nothing happened" rather
    // than a visible snap.
    var htmlEl = document.documentElement;
    var previousScrollBehavior = htmlEl.style.scrollBehavior;
    htmlEl.style.scrollBehavior = "auto";
    window.scrollTo(window.scrollX, scrollLockState.y);
    htmlEl.style.scrollBehavior = previousScrollBehavior;
    scrollLockState = null;
  }

  // ---------------------------------------------------------------------
  // Scroll-safe click helper — second layer of defense around the
  // whole-harvest lock above. Judge.me's real pagination / write-review
  // buttons stay in the DOM (hidden via CSS in sections/dw-reviews-
  // section.liquid) so we can click them programmatically to drive
  // Judge.me's own widget. No .focus() call here — see the hardening
  // note above the scroll lock for why that was removed.
  function clickWithoutScrolling(el) {
    if (!el) return;

    var lockedX = window.scrollX;
    var lockedY = window.scrollY;
    var htmlEl = document.documentElement;
    var previousScrollBehavior = htmlEl.style.scrollBehavior;
    var active = true;

    htmlEl.style.scrollBehavior = "auto";

    function relock() {
      if (active && (window.scrollX !== lockedX || window.scrollY !== lockedY)) {
        window.scrollTo(lockedX, lockedY);
      }
    }

    window.addEventListener("scroll", relock, { passive: true });

    el.click();
    relock();

    setTimeout(function () {
      active = false;
      window.removeEventListener("scroll", relock);
      htmlEl.style.scrollBehavior = previousScrollBehavior;
    }, 500);
  }

  // ---------------------------------------------------------------------
  // Write-review modal product-photo load fix — see the 2026-08-05
  // top-of-file note. Live-tested against the real modal on this store:
  // Judge.me never creates the product-photo element itself, and a plain
  // <img> request for the product's image_url fails even though a
  // fetch() of the exact same URL succeeds — so this always builds the
  // image itself from a fetch()'d blob rather than ever trying a native
  // <img src="..."> request against the original URL.
  // The modal is re-resolved on every single use rather than captured once —
  // Judge.me can replace the modal element while work is still in flight,
  // and a held reference silently goes stale (the same failure mode
  // refreshWidgetReference() handles for the widget itself).
  function getCurrentModal() {
    return document.querySelector(".jdgm-review-widget-modal");
  }

  function fixProductImageLoad() {
    fixProductImageLoad.cache = fixProductImageLoad.cache || {};
    var cache = fixProductImageLoad.cache;

    function getSrc(modal) {
      var existingImg = modal.querySelector(".jdgm-write-review-modal__product-image img");
      if (existingImg) {
        var current = existingImg.getAttribute("src") || "";
        if (current.indexOf("blob:") === 0) return null;
        if (existingImg.complete && existingImg.naturalWidth > 0) return null;
        if (current) return current;
      }
      var dataScript = document.querySelector("script.jdgm-review-widget-data");
      if (dataScript) {
        var m = dataScript.textContent.match(/"image_url":"([^"]*)"/);
        if (m) return m[1].replace(/\\\//g, "/");
      }
      return null;
    }

    function insertOrSwap(blobUrl) {
      // Re-query the LIVE modal and form right now, at insertion time — do
      // not reuse anything captured back when the fetch started.
      // Confirmed live: Judge.me can re-render the modal's form while a
      // fetch() is still in flight, and inserting into the old
      // (now-detached) form silently succeeds in JS but never appears
      // on screen, even though the fetch itself worked fine. Also
      // confirmed live: this selector can match more than one form (one
      // per modal page) — querySelector's first match is the
      // rating-page's form, which is what we want the photo on.
      var modal = getCurrentModal();
      if (!modal) return;
      var liveForm = modal.querySelector(".jdgm-write-review-modal__form");
      if (!liveForm) return;
      var img = modal.querySelector(".jdgm-write-review-modal__product-image img");
      if (img) {
        if (img.src !== blobUrl) {
          img.loading = "eager";
          img.src = blobUrl;
        }
      } else {
        var titleEl = liveForm.querySelector(".jdgm-write-review-modal__product-title");
        var container = document.createElement("div");
        container.className = "jdgm-write-review-modal__product-image";
        var newImg = document.createElement("img");
        newImg.src = blobUrl;
        newImg.alt = titleEl ? titleEl.textContent.trim() : "";
        newImg.loading = "eager";
        container.appendChild(newImg);
        if (titleEl) {
          liveForm.insertBefore(container, titleEl);
        } else {
          liveForm.appendChild(container);
        }
      }
    }

    function ensureImage() {
      var modal = getCurrentModal();
      if (!modal) return;
      var form = modal.querySelector(".jdgm-write-review-modal__form");
      if (!form) return;
      var src = getSrc(modal);
      if (!src) return;

      if (cache[src]) {
        insertOrSwap(cache[src]);
        return;
      }

      var attempts = 0;
      var maxAttempts = 3;
      (function attemptFetch() {
        attempts++;
        fetch(src, { mode: "cors", cache: "no-store" })
          .then(function (res) {
            if (!res.ok) throw new Error("bad status " + res.status);
            return res.blob();
          })
          .then(function (blob) {
            var blobUrl = URL.createObjectURL(blob);
            cache[src] = blobUrl;
            insertOrSwap(blobUrl);
          })
          .catch(function () {
            if (attempts < maxAttempts) setTimeout(attemptFetch, 400 * attempts);
          });
      })();
    }

    // No observer of its own any more. This used to attach a dedicated
    // MutationObserver (keyed on fixProductImageLoad.lastModal) to keep
    // retrying ensureImage() as Judge.me filled the modal in — but that
    // meant holding onto a modal reference, which is exactly what goes
    // stale when Judge.me swaps the element. Now that every lookup goes
    // through getCurrentModal(), the retry loop is watchForModal()'s own
    // observer, which already calls applyModalStyles() on every modal
    // mutation, and applyModalStyles() calls straight back into here.
    ensureImage();
  }

  function ReviewsWidget(root) {
    this.root = root;
    this.jdgmWidget = null;
    this.jdgmHost = null;
    this.emptyEl = root.querySelector("[data-dw-reviews-empty]");
    this.fullEl = root.querySelector("[data-dw-reviews-full]");
    this.loadingEl = root.querySelector("[data-dw-loading]");
    this.listEl = root.querySelector("[data-dw-review-list]");
    this.breakdownEl = root.querySelector("[data-dw-breakdown]");
    this.photosEl = root.querySelector("[data-dw-photos]");
    this.averageEl = root.querySelector("[data-dw-average]");
    this.countEl = root.querySelector("[data-dw-review-count]");
    this.showMoreWrap = root.querySelector("[data-dw-show-more-wrap]");
    this.showMoreBtn = root.querySelector("[data-dw-show-more]");
    this.sortMenu = root.querySelector("[data-dw-sort-menu]");
    this.cardTemplate = document.querySelector("[data-dw-review-card-template]");
    this.writeReviewTriggers = root.querySelectorAll("[data-dw-write-review-trigger]");
    this.lightboxEl = root.querySelector("[data-dw-lightbox]");
    this.lightboxImage = root.querySelector("[data-dw-lightbox-image]");
    this.lightboxClose = root.querySelector("[data-dw-lightbox-close]");
    this.lightboxPrev = root.querySelector("[data-dw-lightbox-prev]");
    this.lightboxNext = root.querySelector("[data-dw-lightbox-next]");
    this.lightboxOverlay = root.querySelector("[data-dw-lightbox-overlay]");
    this.lightboxStars = root.querySelector("[data-dw-lightbox-stars]");
    this.lightboxName = root.querySelector("[data-dw-lightbox-name]");
    this.lightboxVerified = root.querySelector("[data-dw-lightbox-verified]");
    this.lightboxDate = root.querySelector("[data-dw-lightbox-date]");
    this.lightboxTitle = root.querySelector("[data-dw-lightbox-title]");
    this.lightboxBody = root.querySelector("[data-dw-lightbox-body]");
    this.lightboxThumbs = root.querySelector("[data-dw-lightbox-thumbs]");
    this.allPhotos = [];
    this.lightboxIndex = 0;
    this.perPage = parseInt(root.getAttribute("data-per-page"), 10) || 5;
    this.photosVisible = parseInt(root.getAttribute("data-photos-visible"), 10) || 3;
    this.allReviews = [];
    this.sortedReviews = [];
    this.visibleCount = this.perPage;
    this.sortMode = "recent";
    this.photoIndex = 0;
    // harvest-state flags for the multi-page scrape — see
    // scrapeAndRender()/harvestAllReviews() below.
    this._harvesting = false;
    this._harvestedOnce = false;
    this.init();
  }

  ReviewsWidget.prototype.init = function () {
    this.bindSort();
    this.bindShowMore();
    this.bindWriteReview();
    this.bindLightbox();
    this.loadDates();
    this.waitForJudgeMe();
  };

  // 2026-08-25 — fires the date request immediately, in parallel with
  // waitForJudgeMe() and the multi-page harvest walk, so by the time
  // there are reviews to date the dates are usually already in hand.
  //
  // Both arrival orders are covered and it doesn't matter which wins:
  // if the dates land BEFORE any review has been scraped, this callback
  // finds allReviews empty and does nothing, and finishRender() applies
  // them at first paint. If reviews are scraped FIRST, finishRender()
  // finds no dates yet and this callback applies them and re-renders
  // when they arrive.
  ReviewsWidget.prototype.loadDates = function () {
    var self = this;
    whenReviewDates(function () {
      if (self.applyDates() && self.allReviews.length) {
        self.applySortAndRender();
      }
    });
  };

  // Writes created_at onto the scraped review objects themselves, not
  // into the DOM. That's what lets applySortAndRender()'s "recent" sort
  // and renderLightbox()'s date both work without either of them
  // needing to know where the date came from.
  ReviewsWidget.prototype.applyDates = function () {
    if (!reviewDates || !reviewDates.length || !this.allReviews.length) return false;
    var changed = false;
    this.allReviews.forEach(function (review) {
      if (review.dateRaw) return;
      var match = matchReviewDate(reviewDates, review);
      if (match) {
        review.dateRaw = match.createdAt;
        changed = true;
      }
    });
    return changed;
  };

  ReviewsWidget.prototype.waitForJudgeMe = function () {
    var self = this,
      attempts = 0,
      maxAttempts = 100;
    function check() {
      attempts++;
      var host =
          document.querySelector(".shopify-app-block.jdgm-horizon-widget") ||
          document.querySelector('[class*="jdgm-"][class*="-widget"].shopify-app-block') ||
          (document.querySelector(".jdgm-widget") && document.querySelector(".jdgm-widget").closest(".shopify-app-block")),
        widget = host
          ? host.querySelector(".jdgm-widget") || (host.classList.contains("jdgm-widget") ? host : null)
          : document.querySelector(".jdgm-widget");
      if (widget) {
        self.jdgmWidget = widget;
        self.jdgmHost = host || widget;
        self.jdgmHost.setAttribute("data-dw-judgeme-host", "");
        log("Judge.me widget found, watching for changes", widget);
        // 2026-07-24, per Cosette — this used to immediately broadcast
        // Judge.me's own data-shop-review-count/data-shop-average-rating
        // attributes (e.g. "8" reviews) before scrapeAndRender() below had
        // scraped/harvested a single actual review card. Confirmed live:
        // this store's widget attribute says 8, but only 7 real review
        // cards ever render — so this early broadcast showed "8 reviews"
        // for a moment on every load, then renderSummary() (called once
        // the real cards are scraped/harvested) corrected it down to the
        // true count of 7. That correction was the "goes to 8 then
        // reverts to 7" flash. Removed: the only broadcast now is the one
        // from renderSummary(), driven by the actual scraped review
        // count, so anything listening for dw:reviews:summary (e.g. the
        // "X reviews" link near the title in dw-product-section.liquid)
        // gets the right number from the start instead of a wrong one
        // that self-corrects. The fallback in renderSummary() that reads
        // these same widget attributes when zero reviews were scraped is
        // untouched by this — that path is unrelated and still needed.
        self.observeWidget();
        self.scrapeAndRender();
        return;
      }
      if (attempts >= maxAttempts) {
        log(
          "Judge.me widget never appeared on the page. Make sure the Judge.me app block has been added to this product page via the theme customizer."
        );
        self.showEmpty();
        return;
      }
      setTimeout(check, 100);
    }
    check();
  };

  ReviewsWidget.prototype.observeWidget = function () {
    var self = this;
    if (!window.MutationObserver) return;

    this.attachWidgetObserver(this.jdgmWidget);

    // See the 2026-08-05 top-of-file note: this second observer watches
    // the stable outer host (not the widget node itself, which Judge.me
    // can replace wholesale) so we can detect and recover from Judge.me
    // rebuilding its widget out from under the primary observer above.
    if (this.jdgmHost && this.jdgmHost !== this.jdgmWidget) {
      var hostObserver = new MutationObserver(function () {
        self.refreshWidgetReference();
      });
      hostObserver.observe(this.jdgmHost, { childList: true, subtree: true });
      this.hostObserver = hostObserver;
    }

    // Last-resort safety net — see the 2026-08-05 top-of-file note.
    clearTimeout(this._hardTimeout);
    this._hardTimeout = setTimeout(function () {
      if (self.loadingEl && !self.loadingEl.hidden) {
        log("Reviews never resolved after 15s — falling back to the empty state instead of spinning forever.");
        self.showEmpty();
      }
    }, 15000);
  };

  // Attaches (replacing any previous one) the MutationObserver that
  // drives re-scraping whenever Judge.me updates the widget it's
  // watching. Split out of observeWidget() so refreshWidgetReference()
  // below can re-point it at a freshly-rebuilt widget element.
  ReviewsWidget.prototype.attachWidgetObserver = function (widget) {
    var self = this;
    if (this.observer) this.observer.disconnect();
    var observer = new MutationObserver(function () {
      clearTimeout(self._observerTimeout);
      self._observerTimeout = setTimeout(function () {
        self.scrapeAndRender();
      }, 150);
    });
    observer.observe(widget, { childList: true, subtree: true, attributes: true });
    this.observer = observer;
  };

  // See the 2026-08-05 top-of-file note. Re-resolves the live Judge.me
  // widget using the same detection logic as waitForJudgeMe() below; if
  // it finds a different element than the one we're currently watching
  // (Judge.me rebuilt it), re-points this.jdgmWidget and the primary
  // observer at the new one and re-scrapes immediately, rather than
  // leaving the old observer watching a detached, dead element forever.
  ReviewsWidget.prototype.refreshWidgetReference = function () {
    var host =
        document.querySelector(".shopify-app-block.jdgm-horizon-widget") ||
        document.querySelector('[class*="jdgm-"][class*="-widget"].shopify-app-block') ||
        (document.querySelector(".jdgm-widget") && document.querySelector(".jdgm-widget").closest(".shopify-app-block")),
      widget = host
        ? host.querySelector(".jdgm-widget") || (host.classList.contains("jdgm-widget") ? host : null)
        : document.querySelector(".jdgm-widget");
    if (widget && widget !== this.jdgmWidget) {
      log("Judge.me rebuilt its widget element — re-pointing to the new one.");
      this.jdgmWidget = widget;
      this.attachWidgetObserver(widget);
      this.scrapeAndRender();
    }
  };

  // Judge.me's widget paginates its own review list internally, so a
  // plain scrapeReviews() only ever captures whatever page Judge.me
  // currently has rendered — never the full set. The first time we see
  // the widget with real pagination controls (.jm-pagination-controls
  // with more than one page button), we walk every page once via
  // harvestAllReviews() and merge the results before rendering anything.
  // After that first harvest, subsequent DOM mutations (sorting, live
  // updates, etc.) fall back to a normal single-page scrape merged into
  // the existing set — mergeReviews() only ever grows allReviews, it
  // never shrinks it back down to whatever single page happens to be
  // visible at scrape time.
  ReviewsWidget.prototype.scrapeAndRender = function () {
    var self = this,
      widget = this.jdgmWidget;
    if (!widget || this._harvesting) return;

    var cards = widget.querySelectorAll(".jm-review-item"),
      confirmedEmpty = !!widget.querySelector(".jm-no-reviews-state, .jdgm-empty-state");

    if (!cards.length) {
      if (confirmedEmpty && !this.allReviews.length) this.showEmpty();
      return;
    }

    if (!this._harvestedOnce) {
      var pag = widget.querySelector(".jm-pagination-controls");
      if (pag && this.hasMultiplePages(pag)) {
        this._harvesting = true;
        lockPageScroll();
        this.harvestAllReviews(function (harvested) {
          unlockPageScroll();
          self._harvesting = false;
          self._harvestedOnce = true;
          self.mergeReviews(harvested);
          self.finishRender();
        });
        return;
      }
      this._harvestedOnce = true;
    }

    var addedAny = this.mergeReviews(this.scrapeReviews());
    if (addedAny || !this.allReviews.length) {
      this.finishRender();
    }
  };

  ReviewsWidget.prototype.hasMultiplePages = function (pag) {
    return pag.querySelectorAll(".jm-pagination-controls__button--page").length > 1;
  };

  ReviewsWidget.prototype.dedupeKey = function (r) {
    // name + first chunk of body is enough to tell reviews apart without
    // needing a stable ID from Judge.me's DOM (it doesn't expose one on
    // .jm-review-item directly).
    return (r.name || "") + "|" + (r.body || "").slice(0, 80);
  };

  ReviewsWidget.prototype.mergeReviews = function (newReviews) {
    var self = this;
    var known = {};
    this.allReviews.forEach(function (r) {
      known[self.dedupeKey(r)] = true;
    });
    var addedAny = false;
    newReviews.forEach(function (r) {
      var key = self.dedupeKey(r);
      if (!known[key]) {
        known[key] = true;
        self.allReviews.push(r);
        addedAny = true;
      }
    });
    return addedAny;
  };

  ReviewsWidget.prototype.harvestAllReviews = function (callback) {
    var self = this;
    var widget = this.jdgmWidget;
    var merged = [];
    var seen = {};
    var totalExpected = parseInt(widget.getAttribute("data-shop-review-count"), 10);
    if (isNaN(totalExpected)) totalExpected = Infinity;

    function addCurrentPage() {
      self.scrapeReviews().forEach(function (r) {
        var key = self.dedupeKey(r);
        if (!seen[key]) {
          seen[key] = true;
          merged.push(r);
        }
      });
    }

    function getPagination() {
      return widget.querySelector(".jm-pagination-controls");
    }

    function getActivePageLabel() {
      var pag = getPagination();
      if (!pag) return null;
      var active = pag.querySelector(".jm-pagination-controls__button--active");
      return active ? active.textContent.trim() : null;
    }

    function getPageButton(label) {
      var pag = getPagination();
      if (!pag) return null;
      var buttons = pag.querySelectorAll(".jm-pagination-controls__button--page");
      for (var i = 0; i < buttons.length; i++) {
        if (buttons[i].textContent.trim() === label) return buttons[i];
      }
      return null;
    }

    function getNextButton() {
      var pag = getPagination();
      if (!pag) return null;
      var navButtons = pag.querySelectorAll(".jm-pagination-controls__button--nav");
      var next = navButtons[navButtons.length - 1];
      if (!next) return null;
      if (next.disabled || next.classList.contains("jm-button--disabled") || next.getAttribute("aria-disabled") === "true") {
        return null;
      }
      return next;
    }

    var pageCount = 0;
    var maxPages = 20;
    // Judge.me swaps in the new page's review cards asynchronously — the
    // active-page label can update slightly before the cards themselves
    // do. This settle delay runs after we detect the label change and
    // before we scrape, so we don't scrape stale (previous-page) cards.
    var settleDelay = 300;

    function afterPageSettled() {
      addCurrentPage();
      pageCount++;
      var next = getNextButton();
      if (!next || merged.length >= totalExpected || pageCount >= maxPages) {
        log("Harvested " + merged.length + " review(s) across " + pageCount + " page(s) of Judge.me's own widget pagination.");
        callback(merged);
        return;
      }
      var labelBefore = getActivePageLabel();
      clickWithoutScrolling(next);
      waitForPageChange(labelBefore, function () {
        setTimeout(afterPageSettled, settleDelay);
      });
    }

    function waitForPageChange(labelBefore, cb) {
      var waited = 0;
      var maxWait = 3000;
      var interval = setInterval(function () {
        waited += 60;
        var labelNow = getActivePageLabel();
        if ((labelNow && labelNow !== labelBefore) || waited >= maxWait) {
          clearInterval(interval);
          cb();
        }
      }, 60);
    }

    // Always start from page 1 before walking forward — a widget can be
    // sitting on a later page already (e.g. a previous harvest run), and
    // starting the walk from wherever it happens to be would silently
    // skip every earlier page.
    var startLabel = getActivePageLabel();
    if (startLabel !== "1") {
      var page1Btn = getPageButton("1");
      if (page1Btn) {
        clickWithoutScrolling(page1Btn);
        waitForPageChange(startLabel, function () {
          setTimeout(afterPageSettled, settleDelay);
        });
      } else {
        afterPageSettled();
      }
    } else {
      afterPageSettled();
    }
  };

  ReviewsWidget.prototype.finishRender = function () {
    if (!this.allReviews.length) {
      this.showEmpty();
      return;
    }
    this.showFull();
    // 2026-08-25 — covers the case where the date fetch resolved before
    // any review had been scraped, so first paint already has dates
    // rather than rendering blank and correcting a moment later.
    this.applyDates();
    this.renderSummary(this.allReviews.length);
    this.renderBreakdown();
    this.renderPhotos();
    this.applySortAndRender();
  };

  ReviewsWidget.prototype.scrapeReviewCount = function () {
    var widget = this.jdgmWidget;
    if (widget.querySelector(".jm-no-reviews-state, .jdgm-empty-state")) return 0;
    var cards = widget.querySelectorAll(".jm-review-item");
    return cards.length ? cards.length : 0;
  };

  ReviewsWidget.prototype.scrapeReviews = function () {
    var widget = this.jdgmWidget,
      cardEls = widget.querySelectorAll(".jm-review-item"),
      reviews = [];
    return (
      cardEls.forEach(function (card) {
        var nameEl = card.querySelector(".jm-reviewer-info__name"),
          starsEl = card.querySelector(".jm-star-rating"),
          rating = 0;
        if (starsEl) {
          var ariaLabel = starsEl.getAttribute("aria-label") || "",
            m = ariaLabel.match(/^(\d+(?:\.\d+)?)\s+out\s+of/i);
          m && (rating = parseFloat(m[1]));
        }
        var bodyEl = card.querySelector(".jdgm-review-content__body-content"),
          // 2026-07-24: confirmed live against this store's actual review
          // cards — Judge.me's current widget markup does not render a
          // title or a per-review date anywhere in the DOM (verified via
          // DevTools, not just assumed).
          //
          // 2026-08-25: still true of the DOM, which is why both are
          // still initialised empty here. The DATE is now filled in
          // afterwards by applyDates() from Judge.me's public widget
          // endpoint — see the PER-REVIEW DATES section near the top of
          // this file. The TITLE stays permanently blank on purpose:
          // confirmed live that the API returns "" for it on every
          // review, because the current Judge.me review form doesn't
          // collect a title at all. There is nothing to fill it with.
          dateRaw = "",
          title = "",
          verifiedEl = card.querySelector('.jm-verified-badge, [class*="verified"]'),
          photoEls = card.querySelectorAll(".jm-media-thumbnail-list__thumbnail img"),
          photos = [];
        photoEls.forEach(function (img) {
          var src = img.getAttribute("src") || "",
            srcset = img.getAttribute("srcset") || "",
            hires = srcset.match(/(\S+)\s+2x/);
          photos.push(hires ? hires[1] : src);
        });
        reviews.push({
          name: nameEl ? nameEl.textContent.trim() : "Anonymous",
          verified: !!verifiedEl,
          rating: rating,
          title: title,
          body: bodyEl ? bodyEl.textContent.trim() : "",
          dateRaw: dateRaw,
          photos: photos,
        });
      }),
      reviews
    );
  };

  ReviewsWidget.prototype.showEmpty = function () {
    this.loadingEl.hidden = true;
    this.fullEl.hidden = true;
    this.emptyEl.hidden = false;
    broadcastSummary(0, 0);
  };

  ReviewsWidget.prototype.showFull = function () {
    this.loadingEl.hidden = true;
    this.emptyEl.hidden = true;
    this.fullEl.hidden = false;
  };

  ReviewsWidget.prototype.renderSummary = function (reviewCount) {
    var widget = this.jdgmWidget,
      total = this.allReviews.length || reviewCount,
      sum = this.allReviews.reduce(function (acc, r) {
        return acc + (r.rating || 0);
      }, 0),
      avg = this.allReviews.length ? sum / this.allReviews.length : 0;
    if (!this.allReviews.length) {
      var widgetAvg = widget && parseFloat(widget.getAttribute("data-shop-average-rating")),
        widgetCount = widget && parseInt(widget.getAttribute("data-shop-review-count"), 10);
      widgetAvg && !isNaN(widgetAvg) && (avg = widgetAvg);
      widgetCount && !isNaN(widgetCount) && (total = widgetCount);
    }
    this.averageEl.textContent = avg.toFixed(1);
    this.countEl.textContent = total;
    broadcastSummary(total, avg);
  };

  ReviewsWidget.prototype.renderBreakdown = function () {
    var counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    this.allReviews.forEach(function (r) {
      var rating = Math.round(r.rating || 0);
      counts[rating] !== void 0 && counts[rating]++;
    });
    var total = this.allReviews.length || 1,
      starIcon =
        '<svg width="12" height="12" viewBox="0 0 12 12" fill="#835049" xmlns="http://www.w3.org/2000/svg"><path d="M11.7798 4.36341C11.7276 4.21793 11.632 4.09197 11.5059 4.00255C11.3798 3.91313 11.2293 3.86457 11.0748 3.86341H8.02979C7.97841 3.86339 7.92828 3.84754 7.88623 3.81802C7.84419 3.78849 7.81225 3.74673 7.79479 3.69841L6.70479 0.598413C6.64799 0.457999 6.55052 0.33776 6.42491 0.253126C6.29929 0.168491 6.15125 0.123321 5.99979 0.123413C5.84573 0.12415 5.69569 0.172629 5.57033 0.262173C5.44497 0.351718 5.35045 0.477924 5.29979 0.623413L4.20479 3.70841C4.18732 3.75673 4.15539 3.79849 4.11334 3.82802C4.07129 3.85754 4.02116 3.87339 3.96979 3.87341H0.924785C0.770049 3.87385 0.619235 3.92213 0.493019 4.01165C0.366803 4.10116 0.271364 4.22753 0.219785 4.37341C0.170185 4.51763 0.165119 4.67343 0.205246 4.82056C0.245373 4.96769 0.328837 5.09935 0.444785 5.19841L3.03479 7.34841C3.0737 7.38017 3.10215 7.42292 3.11642 7.47108C3.13069 7.51924 3.13012 7.57058 3.11479 7.61841L2.02479 10.8834C1.97345 11.0346 1.9717 11.1982 2.01978 11.3504C2.06786 11.5027 2.16327 11.6356 2.29212 11.7299C2.42097 11.8241 2.57654 11.8748 2.73619 11.8746C2.89584 11.8743 3.05125 11.8231 3.17979 11.7284L5.84979 9.76841C5.89228 9.73637 5.94406 9.71904 5.99729 9.71904C6.05051 9.71904 6.10229 9.73637 6.14479 9.76841L8.81979 11.7284C8.94733 11.8345 9.10648 11.8954 9.27229 11.9014C9.43811 11.9074 9.60124 11.8583 9.73614 11.7617C9.87105 11.665 9.97011 11.5264 10.0178 11.3675C10.0655 11.2086 10.0592 11.0383 9.99979 10.8834L8.90979 7.61841C8.89445 7.57058 8.89388 7.51924 8.90815 7.47108C8.92242 7.42292 8.95087 7.38017 8.98979 7.34841L11.5848 5.19341C11.6971 5.09082 11.7759 4.95668 11.8107 4.80857C11.8455 4.66046 11.8347 4.5053 11.7798 4.36341Z"/></svg>',
      html = "";
    [5, 4, 3, 2, 1].forEach(function (star) {
      var count = counts[star],
        pct = Math.round((count / total) * 100);
      html +=
        '<div class="dw-breakdown-row"><span class="dw-breakdown-row__star"><span class="dw-breakdown-row__star-number">' +
        star +
        "</span>" +
        starIcon +
        '</span><div class="dw-breakdown-row__bar-track"><div class="dw-breakdown-row__bar-fill" style="width:' +
        pct +
        '%;"></div></div><span class="dw-breakdown-row__count">' +
        count +
        "</span></div>";
    });
    this.breakdownEl.innerHTML = html;
  };


  ReviewsWidget.prototype.renderPhotos = function () {
    var self = this,
      photos = [];

    this.allReviews.forEach(function (r) {
      (r.photos || []).forEach(function (url) {
        photos.push({ url: url, review: r });
      });
    });
    this.allPhotos = photos;

    if (!photos.length) {
      this.photosEl.innerHTML = "";
      this.photosEl.hidden = true;
      return;
    }
    this.photosEl.hidden = false;

    var trackHtml = photos
      .map(function (photo, index) {
        return (
          '<button type="button" class="dw-reviews__photo-btn" data-dw-photo-open data-photo-index="' +
          index +
          '"><img class="dw-reviews__photo" src="' +
          photo.url +
          '" alt="Customer review photo" loading="lazy"></button>'
        );
      })
      .join("");

    // Arrows only exist when there are more photos than the section's
    // "Photos visible before carousel" setting allows on a desktop row.
    // They're hidden outright under 990px by the CSS — swipe replaces
    // them there — so this flag is really "does desktop need arrows".
    var showNav = photos.length > this.photosVisible;

    this.photosEl.innerHTML =
      (showNav
        ? '<button type="button" class="dw-reviews__photos-nav" data-dw-photo-prev aria-label="Previous photos">' +
          ICONS.chevronLeft +
          "</button>"
        : "") +
      '<div class="dw-reviews__photos-track" data-dw-photos-track>' +
      trackHtml +
      "</div>" +
      (showNav
        ? '<button type="button" class="dw-reviews__photos-nav" data-dw-photo-next aria-label="Next photos">' +
          ICONS.chevronRight +
          "</button>"
        : "");

    var track = this.photosEl.querySelector("[data-dw-photos-track]");

    // Hand the theme setting to CSS rather than doing the width maths
    // here — the track's max-width rule multiplies this by the current
    // --dw-photo-size, so the breakpoint that changes the photo size
    // doesn't need this JS to know anything about it.
    track.style.setProperty("--dw-photos-visible", this.photosVisible);

    if (showNav) {
      var prevBtn = this.photosEl.querySelector("[data-dw-photo-prev]"),
        nextBtn = this.photosEl.querySelector("[data-dw-photo-next]");

      // One photo + one gap, measured live. Falls back to the old 168
      // only if the track somehow has no rendered photo to measure.
      var stepSize = function () {
        var first = track.querySelector(".dw-reviews__photo-btn");
        if (!first) return 168;
        var gap = parseFloat(getComputedStyle(track).columnGap);
        if (isNaN(gap)) gap = 8;
        return first.getBoundingClientRect().width + gap;
      };

      // Grey out whichever arrow points at nothing. The 1px slack
      // absorbs sub-pixel scrollLeft values, which are routine on
      // trackpads and on high-DPI screens and would otherwise leave an
      // arrow looking live at a hard stop.
      var syncNav = function () {
        var maxScroll = track.scrollWidth - track.clientWidth;
        prevBtn.classList.toggle("is-disabled", track.scrollLeft <= 1);
        nextBtn.classList.toggle("is-disabled", track.scrollLeft >= maxScroll - 1);
      };

      prevBtn.addEventListener("click", function () {
        track.scrollBy({ left: -stepSize(), behavior: "smooth" });
      });
      nextBtn.addEventListener("click", function () {
        track.scrollBy({ left: stepSize(), behavior: "smooth" });
      });

      track.addEventListener("scroll", syncNav, { passive: true });
      window.addEventListener("resize", syncNav);
      syncNav();
    }

    this.photosEl.querySelectorAll("[data-dw-photo-open]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var index = parseInt(btn.getAttribute("data-photo-index"), 10) || 0;
        self.openLightbox(index);
      });
    });
  };

  ReviewsWidget.prototype.bindSort = function () {
    var self = this,
      sortToggle = this.root.querySelector(".dw-reviews__sort .dw-button");
    sortToggle &&
      sortToggle.addEventListener("click", function (e) {
        e.preventDefault();
        self.sortMenu.hidden = !self.sortMenu.hidden;
      });
    this.sortMenu &&
      this.sortMenu.querySelectorAll("li").forEach(function (li) {
        li.addEventListener("click", function () {
          self.sortMode = li.getAttribute("data-sort");
          var label = self.root.querySelector(".dw-reviews__sort .dw-button__text");
          label && (label.textContent = li.textContent);
          self.sortMenu.hidden = true;
          self.visibleCount = self.perPage;
          self.applySortAndRender();
        });
      });
    document.addEventListener("click", function (e) {
      self.sortMenu && !self.sortMenu.hidden && !self.root.contains(e.target) && (self.sortMenu.hidden = true);
    });
  };

  ReviewsWidget.prototype.bindShowMore = function () {
    var self = this;
    this.showMoreBtn &&
      this.showMoreBtn.addEventListener("click", function () {
        self.visibleCount += self.perPage;
        self.renderList();
      });
  };

  ReviewsWidget.prototype.bindWriteReview = function () {
    var self = this;
    this.writeReviewTriggers.forEach(function (trigger) {
      var btn = trigger.querySelector(".dw-button");
      btn &&
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          self.openWriteReview();
        });
    });
  };

  // The reveal-then-hide dance that used to live here (add
  // dw-judgeme-host--active → requestAnimationFrame → click → remove the
  // class 300ms later) is gone: clicking Judge.me's real button works
  // fine while the host is still visually hidden, and the modal it opens
  // is a separate overlay appended outside the widget, so the widget
  // never needed to be visible. The class is still added in the
  // fallback branch below, where we couldn't find the button at all and
  // are exposing the real widget so it can be clicked by hand.
  ReviewsWidget.prototype.openWriteReview = function () {
    var self = this;
    if (!this.jdgmWidget) {
      log("Cannot open write-review form — Judge.me widget was never found on this page.");
      return;
    }
    var jdgmWriteBtn = self.jdgmWidget.querySelector('[data-testid="write-review-button"]');
    if (!jdgmWriteBtn) {
      log('Could not find Judge.me\'s "Write a review" button. Falling back to revealing the widget so it can be clicked directly.');
      this.jdgmHost && this.jdgmHost.classList.add("dw-judgeme-host--active");
      return;
    }

    jdgmWriteBtn.click();
    self.watchForModal();
  };

  ReviewsWidget.prototype.watchForModal = function () {
    var attempts = 0,
      maxAttempts = 40;
    function applyModalStyles() {
      var modal2 = getCurrentModal();
      if (!modal2) return false;
      fixProductImageLoad();
      var bodyFont = getComputedStyle(document.documentElement).getPropertyValue("--dw-font-body") || "inherit",
        headingFont = getComputedStyle(document.documentElement).getPropertyValue("--dw-font-heading") || "inherit";
      modal2.style.setProperty("font-family", bodyFont, "important");
      modal2.querySelectorAll("*").forEach(function (el) {
        el.style.setProperty("font-family", bodyFont, "important");
      });
      var titleGroups = {};
      modal2.querySelectorAll(".jdgm-write-review-modal__title").forEach(function (titleEl) {
        var page = titleEl.closest(".jdgm-write-review-modal__page--thank-you");
        if (page) {
          var key = "thankyou";
          titleGroups[key] = (titleGroups[key] || 0) + 1;
          var isFirst = titleGroups[key] === 1;
          isFirst
            ? (titleEl.style.setProperty("font-family", headingFont, "important"),
              titleEl.style.setProperty("font-size", "32px", "important"),
              titleEl.style.setProperty("color", "#54493A", "important"),
              titleEl.style.setProperty("line-height", "1.2", "important"))
            : (titleEl.style.setProperty("font-family", bodyFont, "important"),
              titleEl.style.setProperty("font-size", "18px", "important"),
              titleEl.style.setProperty("font-weight", "700", "important"),
              titleEl.style.setProperty("color", "#54493A", "important"),
              titleEl.style.setProperty("line-height", "1.4", "important"),
              titleEl.style.setProperty("padding-top", "32px", "important"),
              titleEl.style.setProperty("max-width", "400px", "important"));
        } else
          titleEl.style.setProperty("font-family", headingFont, "important"),
            titleEl.style.setProperty("font-size", "32px", "important"),
            titleEl.style.setProperty("color", "#54493A", "important"),
            titleEl.style.setProperty("line-height", "1.2", "important");
      });
      var thankYouText = modal2.querySelector(".jdgm-write-review-modal__page--thank-you .jdgm-write-review-modal__text");
      thankYouText &&
        (thankYouText.style.setProperty("font-family", bodyFont, "important"),
        thankYouText.style.setProperty("font-size", "18px", "important"),
        thankYouText.style.setProperty("color", "#6C6153", "important"),
        thankYouText.style.setProperty("max-width", "400px", "important"));
      var thankYouIntro = modal2.querySelector(".jdgm-write-review-modal__page--thank-you .jdgm-write-review-modal__intro");
      thankYouIntro && thankYouIntro.style.setProperty("max-width", "400px", "important");
      var starsContainer = modal2.querySelector(".jdgm-write-review-modal__stars-container");
      starsContainer && starsContainer.style.setProperty("margin-top", "50px", "important");
      var intro = modal2.querySelector(".jdgm-write-review-modal__intro");
      intro && (intro.style.setProperty("font-size", "18px", "important"), intro.style.setProperty("color", "#6C6153", "important"));
      var pageHeader = modal2.querySelector(".jdgm-write-review-modal__page-header");
      pageHeader && pageHeader.style.setProperty("padding-top", "32px", "important"),
        modal2.style.setProperty("--jm-review-widget-star-and-histogram-color", "#835049", "important"),
        modal2.style.setProperty("--jm-widget-primary-color", "#835049", "important");
      var content = modal2.querySelector(".jdgm-write-review-modal__content");
      content &&
        (content.style.setProperty("border-radius", "12px", "important"),
        content.style.setProperty("overflow", "hidden", "important"),
        content.style.setProperty("background", "#FFFDF9", "important")),
        modal2.querySelectorAll(".jdgm-write-review-modal__field-input").forEach(function (field) {
          field.style.setProperty("padding", "16px", "important");
          field.style.setProperty("box-sizing", "border-box", "important");
          field.style.setProperty("background", "transparent", "important");
          field.style.setProperty("color", "#54493A", "important");
          field.style.setProperty("font-size", "18px", "important");
        }),
        modal2.style.setProperty("--jm-review-widget-form-field-background-color", "transparent", "important");
      var closeBtn = modal2.querySelector(".jdgm-write-review-modal__close-btn");
      closeBtn &&
        closeBtn.querySelectorAll("svg path").forEach(function (path) {
          path.setAttribute("stroke", "#6C6153");
          path.style.setProperty("stroke", "#6C6153", "important");
        }),
        modal2.querySelectorAll(".jdgm-star").forEach(function (star) {
          star.style.setProperty("color", "#835049", "important");
          var svg = star.querySelector("svg");
          if (svg) {
            var isOn = star.classList.contains("jdgm--on");
            svg.querySelectorAll("path, polygon").forEach(function (shape) {
              shape.setAttribute("fill", isOn ? "#835049" : "none");
              shape.setAttribute("stroke", "#835049");
              shape.style.setProperty("fill", isOn ? "#835049" : "none", "important");
              shape.style.setProperty("stroke", "#835049", "important");
            });
          }
        }),
        modal2.querySelectorAll('[class*="modal__nav-btn"]').forEach(function (btn) {
          var isBack = /nav-btn-back/.test(btn.className);
          isBack
            ? (btn.style.setProperty("background", "transparent", "important"),
              btn.style.setProperty("border", "0", "important"),
              btn.style.setProperty("border-radius", "0", "important"),
              btn.style.setProperty("color", "#6C6153", "important"),
              btn.style.setProperty("padding", "0 0 5px", "important"),
              btn.style.setProperty("min-height", "0", "important"))
            : (btn.style.setProperty("background", "#E2B6B0", "important"),
              btn.style.setProperty("color", "#54493A", "important"),
              btn.style.setProperty("border", "1.2px solid #54493A", "important"),
              btn.style.setProperty("border-radius", "999px", "important"),
              btn.style.setProperty("padding", "0 32px", "important"),
              btn.style.setProperty("min-height", "46px", "important"));
        });
      var overlay = document.querySelector(".jdgm-write-review-modal__overlay");
      return (
        overlay &&
          (overlay.style.setProperty("background", "rgba(0,0,0,0.4)", "important"),
          overlay.style.setProperty("opacity", "1", "important")),
        true
      );
    }
    function check() {
      attempts++;
      !(applyModalStyles() || attempts >= maxAttempts) && setTimeout(check, 100);
    }
    check();
    var modal = document.querySelector(".jdgm-review-widget-modal");
    if (modal && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        applyModalStyles();
      });
      observer.observe(modal, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
    }
    modal &&
      modal.addEventListener(
        "click",
        function (e) {
          e.target.closest && e.target.closest(".jdgm-star") && requestAnimationFrame(applyModalStyles);
        },
        true
      );
  };

  ReviewsWidget.prototype.applySortAndRender = function () {
    var sorted = this.allReviews.slice();
    this.sortMode === "highest"
      ? sorted.sort(function (a, b) {
          return (b.rating || 0) - (a.rating || 0);
        })
      : this.sortMode === "lowest"
      ? sorted.sort(function (a, b) {
          return (a.rating || 0) - (b.rating || 0);
        })
      : sorted.sort(function (a, b) {
          // 2026-08-25 — this used to be
          //   return new Date(b.dateRaw) - new Date(a.dateRaw);
          // which, with dateRaw permanently "" (see scrapeReviews()),
          // evaluated to NaN for every pair. Every comparison involving
          // NaN is false, so the comparator was a silent no-op and
          // "Most Recent" never sorted anything — the list just stayed
          // in scrape order regardless of what the dropdown said. Now
          // that applyDates() fills real dates in, guard the unparseable
          // case explicitly rather than relying on date arithmetic, so
          // a review we couldn't match a date for sinks to the bottom
          // instead of scrambling the order of the ones we could. If
          // the date fetch fails entirely this returns 0 for every
          // pair, i.e. exactly the old no-op behavior.
          var ta = Date.parse(a.dateRaw || "");
          var tb = Date.parse(b.dateRaw || "");
          if (isNaN(ta) && isNaN(tb)) return 0;
          if (isNaN(ta)) return 1;
          if (isNaN(tb)) return -1;
          return tb - ta;
        });
    this.sortedReviews = sorted;
    this.renderList();
  };

  ReviewsWidget.prototype.renderList = function () {
    var self = this,
      reviews = this.sortedReviews.length ? this.sortedReviews : this.allReviews,
      visible = reviews.slice(0, this.visibleCount);
    this.listEl.innerHTML = "";
    visible.forEach(function (review) {
      var node = self.cardTemplate.content.cloneNode(true);
      node.querySelector('[data-field="name"]').textContent = review.name;
      var verifiedEl = node.querySelector('[data-field="verified"]');
      review.verified && ((verifiedEl.hidden = false), (verifiedEl.textContent = "Verified Buyer"));
      node.querySelector('[data-field="stars"]').innerHTML = starsMarkup(review.rating);
      node.querySelector('[data-field="date"]').textContent = formatDate(review.dateRaw);
      node.querySelector('[data-field="title"]').textContent = review.title;
      node.querySelector('[data-field="body"]').textContent = review.body;
      self.listEl.appendChild(node);
    });
    this.showMoreWrap && (this.showMoreWrap.hidden = this.visibleCount >= reviews.length);
  };

  ReviewsWidget.prototype.bindLightbox = function () {
    var self = this;
    this.lightboxEl &&
      (this.lightboxClose &&
        this.lightboxClose.addEventListener("click", function () {
          self.closeLightbox();
        }),
      this.lightboxOverlay &&
        this.lightboxOverlay.addEventListener("click", function () {
          self.closeLightbox();
        }),
      this.lightboxPrev &&
        this.lightboxPrev.addEventListener("click", function () {
          self.stepLightbox(-1);
        }),
      this.lightboxNext &&
        this.lightboxNext.addEventListener("click", function () {
          self.stepLightbox(1);
        }),
      document.addEventListener("keydown", function (e) {
        self.lightboxEl.hidden ||
          (e.key === "Escape" && self.closeLightbox(), e.key === "ArrowLeft" && self.stepLightbox(-1), e.key === "ArrowRight" && self.stepLightbox(1));
      }));
  };

  ReviewsWidget.prototype.openLightbox = function (index) {
    !this.lightboxEl ||
      !this.allPhotos.length ||
      ((this.lightboxIndex = index), this.renderLightbox(), (this.lightboxEl.hidden = false), (document.body.style.overflow = "hidden"));
  };

  ReviewsWidget.prototype.closeLightbox = function () {
    this.lightboxEl && ((this.lightboxEl.hidden = true), (document.body.style.overflow = ""));
  };

  ReviewsWidget.prototype.stepLightbox = function (delta) {
    var total = this.allPhotos.length;
    total && ((this.lightboxIndex = (this.lightboxIndex + delta + total) % total), this.renderLightbox());
  };

  ReviewsWidget.prototype.renderLightbox = function () {
    var self = this,
      photo = this.allPhotos[this.lightboxIndex];
    if (photo) {
      var review = photo.review;
      if (
        (this.lightboxImage && (this.lightboxImage.src = photo.url),
        this.lightboxStars && (this.lightboxStars.innerHTML = starsMarkup(review.rating)),
        this.lightboxName && (this.lightboxName.textContent = review.name || "Anonymous"),
        this.lightboxVerified && (this.lightboxVerified.hidden = !review.verified),
        this.lightboxDate && (this.lightboxDate.textContent = formatDate(review.dateRaw)),
        this.lightboxTitle && (this.lightboxTitle.textContent = review.title || ""),
        this.lightboxBody && (this.lightboxBody.textContent = review.body || ""),
        this.lightboxThumbs)
      ) {
        this.lightboxThumbs.innerHTML = this.allPhotos
          .map(function (p, i) {
            var activeClass = i === self.lightboxIndex ? " is-active" : "";
            return (
              '<button type="button" class="dw-lightbox__thumb' +
              activeClass +
              '" data-thumb-index="' +
              i +
              '"><img src="' +
              p.url +
              '" alt="Customer review photo" loading="lazy"></button>'
            );
          })
          .join("");
        this.lightboxThumbs.querySelectorAll("[data-thumb-index]").forEach(function (btn) {
          btn.addEventListener("click", function () {
            self.lightboxIndex = parseInt(btn.getAttribute("data-thumb-index"), 10) || 0;
            self.renderLightbox();
          });
        });
      }
    }
  };

  function initAll() {
    document.querySelectorAll("[data-dw-reviews]").forEach(function (el) {
      new ReviewsWidget(el);
    });
  }
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", initAll) : initAll();
})();